import { render, staticRenderFns } from "./CompositeList.vue?vue&type=template&id=ba664646&scoped=true"
import script from "./CompositeList.vue?vue&type=script&lang=js"
export * from "./CompositeList.vue?vue&type=script&lang=js"
import style0 from "./CompositeList.vue?vue&type=style&index=0&id=ba664646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba664646",
  null
  
)

export default component.exports